// Question Numbers
const secondDrawQuestion = 601

const form1919v1 = {
  business_basic_info: [315, 403, 404],
  guarantor_legal: [1, 2, 3, 4, 18, 5],
}

const form1919v2 = {
  business_basic_info: [409, 410, 411],
}

const excludeQuestionsByFlow = {
  rfa_lite_loc: {
    business_basic_info: [1301, ...form1919v2.business_basic_info],
  },
  five_phase_multiproduct_loc: {
    business_story: [402, 401, 405, 1301],
    business_basic_info: [1301, ...form1919v2.business_basic_info],
  },
  rfa_lite_sba: form1919v2,
  five_phase_multiproduct_sba_plaid_test_b: form1919v2,
  rfa_lite_conventional: form1919v2,
  five_phase_multiproduct_conventional_plaid_test_b: form1919v2,
  rfa_lite_sba_1919_v2: form1919v1,
  five_phase_multiproduct_sba_1919_v2: form1919v1,
}

class QuestionsUtil {
  constructor({ questions, entity, categoriesQuestions, flowVariant, isPaycheckProtection, cre }) {
    this.questions = questions
    this.entity = entity
    this.isOc = entity?.borrowerType === 'oc'
    this.type = entity.type
    this.isSeniorStaff = !entity.principal && this.type !== 'Business'
    this.categories = JSON.parse(categoriesQuestions)
    this.isPaycheckProtection = isPaycheckProtection
    this.isPaycheckProtectionSecondDraw = flowVariant === 'five_phase_paycheck_protection_payroll_second_draw'
    this.is1919v2 = flowVariant === 'rfa_lite_sba_1919_v2' || flowVariant === 'five_phase_multiproduct_sba_1919_v2'
    this.isCre = cre
    this.excludeQuestions = excludeQuestionsByFlow[flowVariant] || {}
  }

  _isPaycheckProtectionSecondDrawProduct = () => {
    if (!this.isOc) {
      return false
    }

    const { entity: { answers } } = this
    const answerPPPSecondDraw = answers.find(({ questionNumber }) =>  questionNumber === secondDrawQuestion)?.value

    return this.isPaycheckProtection && answerPPPSecondDraw === 'true'
  }

  getOrderedQuestions = keyword => {
    if (this.questions === undefined) {
      return []
    }

    const orderedQuestions = []
    const typeCategory = this.categories[keyword]
    const excludeQuestions = this.excludeQuestions[keyword] || []

    const filteredArray = this.questions.filter(
      ({ number }) =>
        !excludeQuestions.includes(number) && typeCategory.includes(number)
    )

    typeCategory.forEach(q =>
      orderedQuestions.push(filteredArray.find(({ number }) => number === q))
    )

    return orderedQuestions.filter(o => Boolean(o))
  }

  get questions_prequalify() {
    let questions = this.getOrderedQuestions('business_prequalify')

    if (this.isPaycheckProtectionSecondDraw || this.isCre) {
      questions = []
    }

    return questions
  }

  get questions_prequalify_paycheck_protection() {
    return this.isPaycheckProtectionSecondDraw ? this.getOrderedQuestions('business_prequalify_paycheck_protection') : []
  }

  get questions_basic_info() {
    const isBusiness =  this.type === 'Business'
    const keyword = `${isBusiness ? 'business' : 'guarantor'}_basic_info`
    let questions = this.getOrderedQuestions(keyword)

    if (!isBusiness) {
      questions = this.entity?.citizenship !== 'US' ? questions : []
      if (this.isPaycheckProtection) {
        questions = []
      }
    }

    return questions
  }

  get questions_story() {
    return this.getOrderedQuestions('business_story')
  }

  get questions_legal() {
    return !this.isPaycheckProtection ? this.getOrderedQuestions('guarantor_legal') : []
  }

  get questions_demographics() {
    return this.getOrderedQuestions('guarantor_demographics')
  }

  get questions_closing_1919v2() {
    const form1919QuestionsNames = [
      'business_operations',
      'business_value',
      'business_government_and_legal',
      'business_affiliations',
      'business_employment',
    ]
    let questions = []
    
    form1919QuestionsNames.forEach((name) => questions.push(...this.getOrderedQuestions(name)))
    
    return questions
  }

  get questions_closing() {
    const isBusiness = this.type === 'Business'

    if (this.is1919v2) {
      if (isBusiness) {
        return this.questions_closing_1919v2
      } else {
        return []
      }
    } else {
      let keyword = `${isBusiness ? 'business' : 'guarantor'}_sba_required`

      if (this.isSeniorStaff) {
        keyword = 'senior_staff_sba_required'
      }

      return this.getOrderedQuestions(keyword)
    }
  }

  get questions_experience() {
    return this.getOrderedQuestions('guarantor_experience')
  }

  get questions_payroll_info() {
    if (this.isPaycheckProtection && !this.isPaycheckProtectionSecondDraw) {
      return this.getOrderedQuestions('business_payroll_info')
    } else {
      return []
    }
  }

  get questions_payroll_funds() {
    return this.isPaycheckProtectionSecondDraw ? this.getOrderedQuestions('business_payroll_funds') : []
  }

  get questions_payroll_revenue() {
    return this._isPaycheckProtectionSecondDrawProduct() ? this.getOrderedQuestions('business_payroll_revenue') : []
  }

  get questions_payroll_funds_optional() {
    return this.getOrderedQuestions('business_payroll_funds_optional')
  }

  get questions_basic_info_payroll() {
    return this.isPaycheckProtection ? this.getOrderedQuestions('business_basic_info_payroll') : []
  }

  get questions_business_closing_payroll() {
    if (this.isPaycheckProtection && this.isOc) {
      return this.getOrderedQuestions('business_closing_payroll')
    } else {
      return []
    }
  }

  get questions_business_closing_payroll_ppp_second_draw() {
    return this._isPaycheckProtectionSecondDrawProduct() ? this.getOrderedQuestions('business_closing_payroll_ppp_second_draw') : []
  }
}

export default QuestionsUtil
